import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Language} from "../../models/language";
import {Translation} from "../../models/translation";

@Injectable()
export class LanguageControllerService {
  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getLanguages(): Observable<Language[]> {
    return this.http.get(this.baseUrl + "language") as Observable<Language[]>;
  }

  public getAllLanguages(): Observable<Language[]> {
    return this.http.get(this.baseUrl + "all-languages") as Observable<Language[]>;
  }

  public addLanguage(code: string) {
    return this.http.post(this.baseUrl + "language", code);
  }

  public activateLanguage(code: string, activate: boolean) {
    const body = JSON.stringify(activate);
    return this.http.put(this.baseUrl + "language/" + code, body, {responseType: "text"});
  }

  public activateRTL(code: string, rtlActive: boolean) {
    const body = JSON.stringify(rtlActive);
    return this.http.put(this.baseUrl + "language/" + code + "/rtlActive", body, {responseType: "text"});
  }

  public removeLanguage(code: string) {
    return this.http.delete(this.baseUrl + "language/" + code, {responseType: "text"});
  }
}
